import React from 'react';
import { Col, Row } from 'reactstrap';
import { IProjectionMetricsData } from '../../../types';

export const ProjectionMetrics: React.FC<{ data: IProjectionMetricsData, valueFormatter: any }> = ({ data, valueFormatter }) => (
    data && (
        <div className="text-white text-right">
            <Row>
                <Col xs="7">Untrended:</Col>
                <Col xs="5" className="text-truncate">
                    {data.untrended !== null && data.untrended !== undefined ? valueFormatter(data.untrended) : '-'}
                </Col>
            </Row>
            <Row>
                <Col xs="7">Trended:</Col>
                <Col xs="5" className="text-truncate">
                    {data.trended !== null && data.trended !== undefined ? valueFormatter(data.trended) : '-'}
                </Col>
            </Row>
            <Row>
                <Col xs="7">Sale:</Col>
                <Col xs="5" className="text-truncate">
                    {data.sale !== null && data.sale !== undefined ? valueFormatter(data.sale) : '-'}
                </Col>
            </Row>
        </div>
    )
);

export default ProjectionMetrics;
